import { MoneyConnectClientAPI } from "./axios-service-creator";
import { DisclaimerType } from "../const";
import { Disclaimers } from "const/disclaimers";

export const DisclaimerAPI = {
  // getDisclaimerList: (payload) => MoneyConnectClientAPI.post("/common/master/searchDisclaimer", payload),
  getDisclaimerList: () => Promise.resolve({ data: { result: Disclaimers } }),
  // checkFatcaAml: () => MoneyConnectClientAPI.get("/permission/check/aml/fatca"),
  checkFatcaAml: () => MoneyConnectClientAPI.get("/permission/cust-flags/check/aml/fatca"),
  saveFatcaAml: (payload) => MoneyConnectClientAPI.post("/permission/cust-flags/update", payload),
  checkAgeAndDataIncomplete: () => MoneyConnectClientAPI.get("/permission/check/data/age"),
  checkAcceptDisclaimer: (params) => MoneyConnectClientAPI.get("/permission/disclaimer/check", { params }),
  checkAcceptPDPA: () => DisclaimerAPI.checkAcceptDisclaimer({ code: DisclaimerType.PDPA }),
  acceptDisclaimer: (payload) => MoneyConnectClientAPI.post("/permission/disclaimer/accept", payload), // { "code":"DCM01", "language":"TH" }
};
